import React, { useRef } from 'react'
import styles from '../IntroStep.module.scss'
import templateCards from '../introTemplates.json'

function getPreviewName(fileName) {
  return `${fileName.replace(/\.lugsail$/i, '')}.jpg`
}

function prefersReducedMotion() {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}

export default function TemplateRail({ onOpenTemplate, loading }) {
  const railRef = useRef(null)

  const scrollBy = (direction) => {
    const el = railRef.current
    if (!el) return
    el.scrollBy({
      left: direction * Math.max(220, el.clientWidth * 0.8),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    })
  }

  return (
    <section id="templates" className={styles.railSection}>
      <div className={styles.railHead}>
        <h2 className={styles.railTitle}>Or start from a template</h2>
        <div className={styles.railArrows}>
          <button
            type="button"
            className={styles.railArrow}
            aria-label="Scroll templates left"
            onClick={() => scrollBy(-1)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M15 5l-7 7 7 7" />
            </svg>
          </button>
          <button
            type="button"
            className={styles.railArrow}
            aria-label="Scroll templates right"
            onClick={() => scrollBy(1)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      <div className={styles.railViewport}>
        <ul className={styles.rail} ref={railRef}>
          {templateCards.map((template) => (
            <li key={template.id} className={styles.railItem}>
              <button
                type="button"
                className={styles.railCard}
                disabled={loading}
                onClick={() => onOpenTemplate(template)}
              >
                <span className={styles.railFrame}>
                  <span
                    className={styles.railThumb}
                    style={{
                      backgroundImage: [
                        `url(${process.env.PUBLIC_URL}/intro-templates/preview/${getPreviewName(template.fileName)})`,
                        `url(${process.env.PUBLIC_URL}/intro-templates/preview/viz-placeholder.png)`,
                      ].join(', '),
                    }}
                    role="img"
                    aria-label={template.description}
                  />
                </span>
                <span className={styles.railCardTitle}>{template.title}</span>
                <span className={styles.railCardMeta}>
                  {loading ? template.loadingLabel : template.tags.slice(0, 2).join(' · ')}
                </span>
              </button>
            </li>
          ))}
        </ul>
        {/* Says "this continues" without depending on a scrollbar the OS may
            be hiding until the user already scrolls. */}
        <div className={styles.railFade} aria-hidden="true" />
      </div>
    </section>
  )
}
